export const INPUT_ID = 'vr_name'
export const SELECT_ID = 'vr_linked_hall'
